import get from 'lodash/get';

import type { Application } from '../@types/app';
import type { CookieKey } from '../modules/cookie';
import { Cookie } from '../modules/cookie';

import { isServer } from './isServer';

export const getCookieFromServerOrClient = (
  ctx: Application.IKoaContext | Application.ReduxNextPageContext,
  cookieName: CookieKey,
) => {
  if (isServer) {
    return get(ctx.req.cookies, cookieName);
  }
  return Cookie.get(cookieName);
};
